import {
    RNLTD,
    RNLTDFetchArgs,
    getRNLTDs,
  } from '../assets/ts/data/rnltd'
  import useServerData from './use-server-data'
  
  function useRNLTDMetadata(
    fetchArgs: RNLTDFetchArgs,
    waitOnParentDependency = false
  ) {
    const {
      data: RNLTDMetadata,
      error: RNLTDMetadataError,
      fetchData: fetchRNLTDMetdata,
      isLoading: RNLTDMetadataIsLoading,
    } = useServerData<RNLTD, RNLTDFetchArgs>(
      getRNLTDs,
      fetchArgs,
      waitOnParentDependency
    )
  
    return {
      RNLTDMetadata,
      RNLTDMetadataError,
      RNLTDMetadataIsLoading,
      fetchRNLTDMetdata,
    }
  }
  
  export default useRNLTDMetadata